/**
 * IdeasList Styles
 * Extracted per Cursor Rules (<300 lines per file)
 */

import { StyleSheet } from 'react-native';
import { color, text, space, radius, icon, touch, shadow, layout } from '../../../../shared/tokens/mobile';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  scrollContent: {
    padding: space.md,
    paddingBottom: layout.scrollBottomPadding,
    gap: space.md,
  },
  
  // Header
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: space.md,
  },
  headerTitle: {
    fontSize: text.sectionTitle.fontSize,
    fontWeight: text.sectionTitle.fontWeight,
    color: color.textPrimary,
    flex: 1,
  },
  addButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: space.xs,
    paddingHorizontal: space.md,
    paddingVertical: space.sm,
    backgroundColor: color.primary,
    borderRadius: radius.md,
  },
  addButtonText: {
    fontSize: text.body.fontSize,
    fontWeight: '600',
    color: color.surface,
  },
  
  // Filters
  filtersContainer: {
    flexDirection: 'row',
    gap: space.sm,
  },
  filterScroll: {
    flexGrow: 0,
  },
  filterChip: {
    paddingHorizontal: space.md,
    paddingVertical: space.sm,
    backgroundColor: color.surface,
    borderRadius: radius.full,
    borderWidth: 1,
    borderColor: color.border,
    marginRight: space.xs,
  },
  filterChipActive: {
    backgroundColor: color.primaryLight,
    borderColor: color.primary,
  },
  filterChipText: {
    fontSize: text.caption.fontSize,
    color: color.textSecondary,
  },
  filterChipTextActive: {
    color: color.primary,
    fontWeight: '600',
  },
  
  // Empty state
  emptyContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: space.xxl,
    paddingHorizontal: space.lg,
  },
  emptyIcon: {
    width: 80,
    height: 80,
    borderRadius: 40,
    backgroundColor: color.primaryLight,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: space.lg,
  },
  emptyTitle: {
    fontSize: text.sectionTitle.fontSize,
    fontWeight: text.sectionTitle.fontWeight,
    color: color.textPrimary,
    marginBottom: space.sm,
  },
  emptyText: {
    fontSize: text.body.fontSize,
    color: color.textSecondary,
    textAlign: 'center',
    marginBottom: space.lg,
  },
  emptyButton: {
    backgroundColor: color.primary,
    paddingHorizontal: space.lg,
    paddingVertical: space.md,
    borderRadius: radius.md,
  },
  emptyButtonText: {
    fontSize: text.body.fontSize,
    fontWeight: '600',
    color: color.surface,
  },
  
  // List
  listContainer: {
    gap: space.md,
  },
  
  // Loading
  loadingContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: space.xxl,
  },
  loadingText: {
    fontSize: text.body.fontSize,
    color: color.textMuted,
    marginTop: space.md,
  },
  
  // Error
  errorContainer: {
    alignItems: 'center',
    padding: space.xxl,
  },
  errorText: {
    fontSize: text.body.fontSize,
    color: color.error,
    textAlign: 'center',
    marginTop: space.md,
    marginBottom: space.lg,
  },
  retryButton: {
    backgroundColor: color.primary,
    paddingHorizontal: space.lg,
    paddingVertical: space.md,
    borderRadius: radius.md,
  },
  retryButtonText: {
    fontSize: text.body.fontSize,
    fontWeight: '600',
    color: color.surface,
  },
});

